import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IntercomModule } from '@epicuro-next/platform/intercom';
import { EffectsModule } from '@ngrx/effects';
import { RoutingEffects } from './effects/routing.effects';
import { UserEffects } from './effects/user.effects';
import { BasketEffects } from './effects/basket.effects';

@NgModule({
  imports: [
    CommonModule,
    IntercomModule,
    EffectsModule.forFeature([RoutingEffects, UserEffects, BasketEffects]),
  ],
})
export class StateIntercomModule {}
